import { render } from "./ScoreDGL.vue?vue&type=template&id=c0100af8&scoped=true"
import script from "./ScoreDGL.vue?vue&type=script&lang=js"
export * from "./ScoreDGL.vue?vue&type=script&lang=js"

import "./ScoreDGL.vue?vue&type=style&index=0&id=c0100af8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0100af8"]])

export default __exports__